import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { CounterBody } from './CounterBody/CounterBody.js';

var Counter = forwardRef(function (_a, ref) {
    var _b = _a.tooltipTitle, tooltipTitle = _b === void 0 ? '' : _b, rest = __rest(_a, ["tooltipTitle"]);
    var counterBody = React.createElement(CounterBody, __assign({ "data-testid": "Counter" }, rest, { ref: ref }));
    return (React.createElement(React.Fragment, null,
        tooltipTitle && React.createElement(Tooltip, { title: tooltipTitle }, counterBody),
        !tooltipTitle && counterBody));
});

export { Counter };
